"use client";

import { useTranslations } from "use-intl";

import { CatalogOfferPrices } from "@/components/marketplace/CatalogOfferPrices";
import { OfferActionCta } from "@/components/marketplace/deal-offer-shared";
import type { OfferSummary } from "@/components/marketplace/offer-summary-badge";
import { useRastrPurchaseHref } from "@/hooks/useRastrPurchaseHref";
import { cn } from "@/lib/utils";
import type { OfferSummaryByCondition } from "@garimpa/lib/offerConditions";

export function OfferSummaryCta({
  offer,
  summary,
  className,
}: {
  offer: OfferSummary;
  summary?: OfferSummaryByCondition<OfferSummary>;
  className?: string;
}) {
  const t = useTranslations("shared.affiliates");
  const purchaseHref = useRastrPurchaseHref(offer.bestOfferPurchaseUrl);
  return (
    <div className={cn("pointer-events-none relative z-10 mt-1.5 min-w-0", className)}>
      <CatalogOfferPrices
        summary={
          summary ?? {
            newOffer: offer.bestOfferCondition === "used" ? null : offer,
            usedOffer: offer.bestOfferCondition === "used" ? offer : null,
          }
        }
        destination={{ to: "/release/$id", params: { id: offer.bestReleaseId } }}
      />
      <OfferActionCta
        href={purchaseHref}
        actionLabel={t("viewOffer")}
        ariaLabel={`${t("viewOffer")} · ${offer.providerDisplayName}`}
        providerIconUrl={offer.providerIconUrl}
        pendingLabel={t("linkPending")}
        variant="solid"
        className="pointer-events-auto mt-1.5 min-h-10 w-full"
      />
    </div>
  );
}
